function Link(props = {}) {
  const { text, to, ...rest } = props;
  return (
    <a {...rest} href={to} target='_blank' rel='noopener noreferrer'>
      {text}
    </a>
  );
}

export default Link;
